import React from 'react';
import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DateRangePickerProps {
  period: '7d' | '30d' | '90d' | 'custom';
  startDate?: string;
  endDate?: string;
  onPeriodChange: (period: '7d' | '30d' | '90d' | 'custom') => void;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  period,
  startDate,
  endDate,
  onPeriodChange,
  onStartDateChange,
  onEndDateChange
}) => {
  const { t } = useTranslation();

  const periodOptions = [
    { value: '7d', label: t('statistics.ui.lastDays') },
    { value: '30d', label: t('statistics.ui.last30Days') },
    { value: '90d', label: t('statistics.ui.last90Days') },
    { value: 'custom', label: t('statistics.ui.custom') }
  ];

  return (
    <div className="flex flex-wrap items-center gap-4">
      <div className="flex items-center gap-2">
        <Calendar className="w-5 h-5 text-gray-500" />
        <select
          value={period}
          onChange={(e) => onPeriodChange(e.target.value as typeof period)}
          className="px-3 py-2.5 sm:py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-sm min-h-[44px] focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          {periodOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {period === 'custom' && (
        <div className="flex flex-col sm:flex-row sm:items-center gap-2">
          <input
            type="date"
            value={startDate || ''}
            onChange={(e) => onStartDateChange(e.target.value)}
            className="px-3 py-2.5 sm:py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-sm min-h-[44px] focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          />
          <span className="text-gray-500">{t('statistics.ui.to')}</span>
          <input
            type="date"
            value={endDate || ''}
            onChange={(e) => onEndDateChange(e.target.value)}
            className="px-3 py-2.5 sm:py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-sm min-h-[44px] focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
